export const DEFAULT_WIDTH = 450;
export const MIN_WIDTH = 360;
export const ABSOLUTE_MAX_WIDTH = 900;
export const MOBILE_BREAKPOINT_PX = 768;
export const VIEWPORT_EDGE_PADDING = 80;

export const LS_KEY = 'npi.vantage.clientChat.v1';

export const KEYBOARD_RESIZE_STEP_PX = 16;
export const KEYBOARD_RESIZE_LARGE_STEP_PX = 64;

export const COMPOSER_MAX_HEIGHT_PX = 240;

export const MAX_ATTACHMENTS_PER_MESSAGE = 5;
export const MAX_BYTES_PER_ATTACHMENT = 25 * 1024 * 1024; // 25 MB
export const MAX_BYTES_PER_MESSAGE = 50 * 1024 * 1024; // 50 MB

export const ACCEPTED_FILE_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.txt',
  '.md',
  '.rtf',
  '.csv',
  '.xls',
  '.xlsx',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp'
] as const;

export const ACCEPT_ATTRIBUTE = ACCEPTED_FILE_EXTENSIONS.join(',');

export const DRAWER_ELEMENT_ID = 'client-chat-drawer';
export const LAUNCHER_ELEMENT_ID = 'client-chat-launcher';

export const computeMaxWidth = (innerWidth: number): number => Math.max(MIN_WIDTH, innerWidth - VIEWPORT_EDGE_PADDING);

export const clampWidth = (width: number, innerWidth: number): number => {
  const max = computeMaxWidth(innerWidth);
  if (!Number.isFinite(width)) return DEFAULT_WIDTH;
  return Math.min(Math.max(width, MIN_WIDTH), max);
};
